/* Nūvo — search overlay.
   Opens from the header search icon, queries Shopify predictive search and
   renders product cards. /search/suggest.json does NOT return variant IDs, so
   Add-to-cart fetches /products/<handle>.js first: single available variant ->
   straight into the cart; anything with options -> go to the product page so a
   size can be chosen. Captures fetch at load and never reassigns window.fetch. */
(function () {
  'use strict';
  if (window.__nuvoSearchInit) return;
  window.__nuvoSearchInit = true;

  var origFetch = window.fetch;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  var el, panel, input, grid, empty, trending, seedHTML, lastQ = '', timer = null, ctrl = null;

  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'GBP' })
        .format(cents);
    } catch (e) { return '£' + Number(cents).toFixed(2); }
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function img(url, w) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + w : url + '?width=' + w;
  }

  // Drop the panel clear of the sticky header (+ announcement / countdown bars),
  // otherwise the search bar renders underneath them and looks missing.
  function position() {
    if (!panel) return;
    var top = 0;
    ['.nuvo-header', '#shopify-section-nuvo_announcement', '#shopify-section-nuvo_countdown'].forEach(function (sel) {
      var n = document.querySelector(sel);
      if (!n) return;
      var r = n.getBoundingClientRect();
      if (r.height && r.bottom > top) top = r.bottom;
    });
    top = Math.max(0, Math.round(top)) + 12;
    panel.style.marginTop = top + 'px';
    panel.style.maxHeight = 'calc(100vh - ' + (top + 16) + 'px)';
  }

  function open() {
    if (!el) return;
    el.hidden = false;
    position();
    // next frame so the transition runs
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    document.documentElement.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 60);
  }
  function close() {
    if (!el) return;
    el.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(function () { el.hidden = true; }, 220);
  }

  function card(p) {
    var price = p.price_min !== p.price_max
      ? '<span class="nuvo-scard__from">From</span> ' + money(p.price_min) + ' &ndash; ' + money(p.price_max)
      : money(p.price);
    return '' +
      '<article class="nuvo-scard">' +
        '<a class="nuvo-scard__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.image ? '<img src="' + esc(img(p.image, 420)) + '" alt="" loading="lazy" width="210" height="210">' : '') +
        '</a>' +
        '<div class="nuvo-scard__body">' +
          '<a class="nuvo-scard__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<p class="nuvo-scard__price">' + price + '</p>' +
          (p.type ? '<p class="nuvo-scard__type">' + esc(p.type) + '</p>' : '') +
          '<button type="button" class="nuvo-scard__add" data-search-add data-handle="' + esc(p.handle) + '">Add to cart</button>' +
        '</div>' +
      '</article>';
  }

  function search(q) {
    if (ctrl) ctrl.abort();
    ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var url = root + 'search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=8';
    origFetch(url, { signal: ctrl ? ctrl.signal : undefined, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var ps = (((data || {}).resources || {}).results || {}).products || [];
        if (!ps.length) {
          grid.innerHTML = '';
          empty.textContent = 'No products match “' + q + '”.';
          empty.hidden = false;
          return;
        }
        empty.hidden = true;
        grid.innerHTML = ps.map(card).join('');
      })
      .catch(function (e) { if (e && e.name === 'AbortError') return; });
  }

  function onType() {
    var q = input.value.trim();
    if (q === lastQ) return;
    lastQ = q;
    clearTimeout(timer);
    if (!q) {
      if (ctrl) ctrl.abort();
      grid.innerHTML = seedHTML;
      empty.hidden = true;
      if (trending) trending.hidden = false;
      return;
    }
    if (trending) trending.hidden = true;
    timer = setTimeout(function () { search(q); }, 220);
  }

  function addToCart(btn) {
    var handle = btn.getAttribute('data-handle');
    if (!handle) return;
    var label = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding…';
    origFetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        // more than one option to choose from -> let them pick on the product page
        if ((p.variants || []).length > 1) { window.location.href = root + 'products/' + handle; return null; }
        if (!avail.length) { btn.textContent = 'Sold out'; return null; }
        return origFetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ items: [{ id: avail[0].id, quantity: 1 }] })
        }).then(function (r) { return r.json(); });
      })
      .then(function (res) {
        if (!res) return;
        btn.textContent = 'Added ✓';
        document.dispatchEvent(new CustomEvent('nuvo:cart:changed'));
        setTimeout(function () { btn.disabled = false; btn.textContent = label; }, 1600);
        close();
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
      })
      .catch(function () { btn.disabled = false; btn.textContent = label; });
  }

  function init() {
    el = document.querySelector('[data-nuvo-search]');
    if (!el) return;
    panel = el.querySelector('.nuvo-search__panel');
    input = el.querySelector('[data-search-input]');
    grid = el.querySelector('[data-search-grid]');
    empty = el.querySelector('[data-search-empty]');
    trending = el.querySelector('[data-search-trending]');
    seedHTML = grid ? grid.innerHTML : '';

    document.addEventListener('click', function (e) {
      var opener = e.target.closest('[data-nuvo-search-open]');
      if (opener) { e.preventDefault(); open(); return; }
      if (!el || el.hidden) return;
      if (e.target.closest('[data-search-close]')) { e.preventDefault(); close(); return; }
      var term = e.target.closest('[data-search-term]');
      if (term) {
        e.preventDefault();
        input.value = term.getAttribute('data-search-term');
        input.focus();
        onType();
        return;
      }
      var add = e.target.closest('[data-search-add]');
      if (add) { e.preventDefault(); addToCart(add); return; }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && el && !el.hidden) close();
    });

    window.addEventListener('resize', function () { if (el && !el.hidden) position(); });

    if (input) {
      input.addEventListener('input', onType);
      // let Enter submit the form through to /search for the full results page
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
